export interface Location {
  id: number;
  name_th: string;
  name_en: string;
}

export interface Property {
  id: number;
  code: string;
  name_th: string;
  name_en: string;
  property_id: string;
  country: string;
  attribute_2: string;
  location: string;
  department: string;
  property_type: string;
}
export interface Building {
  id: number;
  electric_range_calculations: RangCalculation[];
  water_range_calculations: RangCalculation[];
  building_id: string;
  name: string;
  code: string;
  alias: string;
  status: string;
  address_detail_th: string;
  address_detail_en: string;
  abbr: string;
  advance_rental_thai_onetime: number;
  advance_rental_foreign_onetime: number;
  advance_rental_company_onetime: number;
  security_deposit_thai_onetime: number;
  security_deposit_foreign_onetime: number;
  security_deposit_company_onetime: number;
  prefix_billing: string;
  branch_code: string;
  running_number_reference_2: number;
  type1_electric_per_unit: number;
  type1_water_per_unit: number;
  type2_electric_water_flat_rate: number;
  type3_electric_flat_rate: number;
  type3_water_flat_rate: number;
  type4_direct_payment_electric: number;
  type4_direct_payment_water: number;
  type5_special_calculation: number;
  property: number;
  operation_unit: number;
  note: number;
  building_tax_rate?: number;
  natural_break_rate_water?: number | string;
  natural_break_rate_electric?: number | string;
  land_and_building_tax_rate?: number;
}

export interface RangCalculation {
  start_range: number;
  end_range: number;
  rate_per_unit: number;
}

export interface OperationUnit {
  branch_name: string;
  branch_name_en: string;
  bank: number;
  bank_no: string;
  address_en: string;
  tax_id: string;
  id?: number;
  organization_id: number;
  code: string;
  name_th: string;
  name_en: string;
  description: string;
  address: string;
  province: string;
  country: string;
  postal_code: string;
  phone_number: string;
  secondary_phone_number: string;
}

export interface Floor {
  id?: number;
  floor_id: number;
  name: string;
  code: string;
  alias: string;
  status: string;
  building: number;
  alias_for_pdf: string;
}

export interface Office {
  id?: number;
  building: number;
  floor_name: string;
  office_id: string;
  code: string;
  alias: string;
  status: string;
  status_2?: any;
  include_in_calculation: boolean;
  area: number;
  weight: number;
  rental_fee: number;
  service_fee: number;
  common_service_fee: number;
  office_type: string;
  show_on_office_dashboard: boolean;
  electric_calculation_type: string;
  water_calculation_type: string;
  floor: number;
  water_rate?: any;
  water_range_calculations?: any;
  electricity_rate?: any;
  electric_range_calculations?: any;
  land_and_building_tax_rate?: number;
  abbreviation: string;
  alias_for_pdf: string;
}
export interface Billing {
  id: number;
  name_th: string;
  name_en: string;
  purpose_code: string;
  amount_vat: number;
  net_price_after_vat: number;
  amount_withholding_tax: number;
  net_price: number;
  building_code: string;
  building_name: string;
  schedule_day: number;
  payment_term: string;
  type: string;
  currency: string;
  price: number;
  start_date: Date;
  end_date: Date;
  order: number;
  billing_type: string;
  vat: string;
  tax_inclusive: string;
  transaction_type: string;
  rev_class: string;
  rev_account: string;
  rec_class: string;
  rec_account: string;
  withholding_tax_percent: number;
  natural_break_rate: number;
  payment_term_template: string;
  office_type: string;
  purpose_code_for_oracle: string;
  building: Building;
  purpose: Purpose;
  floor: Array<Floor>;
  office: Array<Office>;
  offices: Array<Office>;
  floors: Array<Floor>;
  enable_partial_calculation: boolean;
  office_alias_lists: any[];
}

export interface ProductList {
  id: number;
  build_code: string;
  building: number | Building;
  cost: string;
  group: string;
  item: string;
  location_type: number;
  location_type_name: string;
  quantity: number;
  recieve_room_complete: boolean;
  recieve_room_incomplete: boolean;
  room_type: string;
  transfer_room_complete: boolean;
  transfer_room_incomplete: boolean;
  unit: string;
}
export interface Result {
  count: number;
  next: number;
  previous: number;
  results:
    | Location[]
    | Property[]
    | Building[]
    | OperationUnit[]
    | Floor[]
    | Office[]
    | Billing[]
    | ProductList[]
    | Purpose[]
    | SpecialCondition[];
}

export interface Purpose {
  id: number;
  description: string;
  name_th: string;
  name_en: string;
  code?: string;
}

export interface SpecialCondition {
  id: number;
  property_type: string;
  name_th: string;
  name_en: string;
  detail_en?: string;
  detail_th?: string;
}
export const PROPERTY_TYPES = [
  {
    label: 'Apartment',
    label_th: 'อพาร์ทเม้นท์',
    value: 'apartment',
  },
  {
    label: 'Car Park',
    label_th: 'ที่จอดรถ',
    value: 'car_park',
  },
  {
    label: 'Residence',
    label_th: 'ที่พักอาศัย',
    value: 'residence',
  },
  {
    label: 'SHOP House',
    label_th: 'ตึกแถว',
    value: 'shop_house',
  },
  {
    label: 'SHOP',
    label_th: 'ร้านค้า',
    value: 'shop',
  },
  {
    label: 'CHOD BIZ',
    label_th: 'โชติ บิซ',
    value: 'chod_biz',
  },
  {
    label: 'Warehouse / Showroom',
    label_th: 'คลังสินค้า / โชว์รูม',
    value: 'warehouse',
  },
  {
    label: 'Land',
    label_th: 'ที่ดิน',
    value: 'land',
  },
  {
    label: 'Facility Area',
    label_th: 'พื้นที่สาธารณะ',
    value: 'facility_area',
  },
  {
    label: 'Office',
    label_th: 'สำนักงาน',
    value: 'office',
  },
];

export const BILLING_TYPES = [
  {
    label: 'One Time',
    label_th: 'ชำระรายครั้ง',
    value: 'LO',
  },
  {
    label: 'Monthly',
    label_th: 'ชำระรายเดือน',
    value: 'LM',
  },
  {
    label: 'Annually',
    label_th: 'ชำระรายปี',
    value: 'LA',
  },
  {
    label: 'Quarterly',
    label_th: 'ชำระรายไตรมาส',
    value: 'LQ',
  },
  {
    label: 'Semiannually',
    label_th: 'ชำระรายครึ่งปี',
    value: 'LS',
  },
];

export const PAYMENT_TERMS = [
  {
    label: '30 Days',
    value: '30 Days',
  },
  {
    label: 'IMMEDIATE',
    value: 'IMMEDIATE',
  },
  {
    label: '5 Days',
    value: '5 Days',
  },
  {
    label: '5th-Month',
    value: '5th-Month',
  },
  {
    label: '10th-Month',
    value: '10th-Month',
  },
  {
    label: '25th-Month',
    value: '25th-Month',
  },
  {
    label: '1th-Month',
    value: '1th-Month',
  },
  {
    label: '50 Days',
    value: '50 Days',
  },
  {
    label: '10 Days',
    value: '10 Days',
  },
  {
    label: '15th-Month',
    value: '15th-Month',
  },
  {
    label: '20th-Month',
    value: '20th-Month',
  },
  {
    label: 'LC',
    value: 'LC',
  },
  {
    label: 'C.A.D.',
    value: 'C.A.D.',
  },
  {
    label: 'Cash',
    value: 'Cash',
  },
  {
    label: '7 Days',
    value: '7 Days',
  },
  {
    label: '15 Days',
    value: '15 Days',
  },
  {
    label: '45 Days',
    value: '45 Days',
  },
  {
    label: '60 Days',
    value: '60 Days',
  },
  {
    label: '90 Days',
    value: '90 Days',
  },
  {
    label: '25 Days',
    value: '25 Days',
  },
  {
    label: '30th-Month',
    value: '30th-Month',
  },
];

export const OFFICE_STATUS = [
  {
    label_en: 'Available',
    label_th: 'ว่าง',
    value: 'available',
  },
  {
    label_en: 'Reserved',
    label_th: 'ติดจอง',
    value: 'reserved',
  },
  {
    label_en: 'In Process',
    label_th: 'อยู่ระหว่างทำสัญญา',
    value: 'in_process',
  },
  {
    label_en: 'Occupied',
    label_th: 'เช่าแล้ว',
    value: 'occupied',
  },
  {
    label_en: 'Renovate',
    label_th: 'อยู่ระหว่างการซ่อม',
    value: 'renovate',
  },
  {
    label_en: 'Wait to move in',
    label_th: 'รอย้ายเข้า',
    value: 'wait_to_move_in',
  },
  {
    label_en: 'Wait to move out',
    label_th: 'รอย้ายออก',
    value: 'wait_to_move_out',
  },
  {
    label_en: 'Contract Ended',
    label_th: 'หมดอายุสัญญา',
    value: 'contract_expired',
  },
];

export const OFFICE_TYPE = [
  {
    label_th: 'ห้องเช่า',
    label: 'Room',
    value: 'room',
  },
  {
    label_th: 'พื้นที่',
    label: 'Area',
    value: 'area',
  },
];

export const ELECTRIC_CALCULATION_TYPES = [
  {
    label_th: 'ประเภทที่ 1: ค่าไฟฟ้าต่อหน่วย',
    label: 'Type 1: Electricity bill per unit',
    value: 'type1',
  },
  {
    label_th: 'ประเภทที่ 2: ค่าไฟฟ้าและค่าน้ำประปาแบบเหมาจ่าย',
    label: 'Type 2: Electricity and water flat rate',
    value: 'type2',
  },
  {
    label_th: 'ประเภทที่ 3: ค่าไฟฟ้าแบบเหมาจ่าย',
    label: 'Type 3: Electricity flat rate',
    value: 'type3',
  },
  {
    label_th: 'ประเภทที่ 4: ชำระโดยตรงกับการไฟฟ้านครหลวง/ส่วนภูมิภาค',
    label:
      'Type 4: Direct payment to the Metropolitan/Provincial Electricity Authority',
    value: 'type4',
  },
  {
    label_th: 'ประเภทที่ 5: ชำระตามการคำนวณที่บริษัทกำหนด',
    label: 'Type 5: Calculation specified by the company',
    value: 'type5',
  },
  {
    label_th: 'ประเภทที่ 6: ค่าไฟฟ้าตามช่วงเงื่อนไข',
    label: 'Type 6: Electricity Range',
    value: 'type6',
  },
];

export const WATER_CALCULATION_TYPES = [
  {
    label_th: 'ประเภทที่ 1: ค่าน้ำประปาต่อหน่วย',
    label: 'Type 1: Water bill per unit',
    value: 'type1',
  },
  {
    label_th: 'ประเภทที่ 2: ค่าไฟฟ้าและค่าน้ำประปาแบบเหมาจ่าย',
    label: 'Type 2: Electricity and water flat rate',
    value: 'type2',
  },
  {
    label_th: 'ประเภทที่ 3: ค่าน้ำประปาแบบเหมาจ่าย',
    label: 'Type 3: Water flat rate',
    value: 'type3',
  },
  {
    label_th: 'ประเภทที่ 4: ชำระโดยตรงกับการประปานครหลวง/ส่วนภูมิภาค',
    label:
      'Type 4: Direct payment to the Metropolitan/Provincial Waterworks Authority',
    value: 'type4',
  },
  {
    label_th: 'ประเภทที่ 5: ชำระตามการคำนวณที่บริษัทกำหนด',
    label: 'Type 5: Calculation specified by the company',
    value: 'type5',
  },
  {
    label_th: 'ประเภทที่ 6: ค่าน้ำประปาตามช่วงเงื่อนไข',
    label: 'Type 6: Water Range',
    value: 'type6',
  },
];
export const WHT = [
  {
    label_th: 'ไม่มี',
    label: 'Non',
    value: 'non',
  },
  {
    label_th: '3%',
    label: '3%',
    value: '3%',
  },
  {
    label_th: '5%',
    label: '5%',
    value: '5%',
  },
];

export const AJUST_WHT = [
  {
    label_th: '0.00',
    label: '0.00',
    value: 'non',
  },
  {
    label_th: '3%',
    label: '3%',
    value: '3%',
  },
  {
    label_th: '5%',
    label: '5%',
    value: '5%',
  },
];

export const MASTER_DATA_LIST: MasterDatMenues[] = [
  {
    name: 'location',
    label: 'Location',
    label_th: 'สถานที่',
    icon: 'assets/svg/icon-menu/carbon_building.svg',
  },
  {
    name: 'property',
    label: 'Property',
    label_th: 'สินทรัพย์',
    icon: 'assets/svg/icon-menu/view--mode-2.svg',
  },
  {
    name: 'operation_unit',
    label: 'Operation Unit',
    label_th: 'หน่วยงาน',
    icon: 'assets/svg/icon-menu/carbon_location-company.svg',
  },
  {
    name: 'building',
    label: 'Building',
    label_th: 'อาคาร',
    icon: 'assets/svg/icon-menu/carbon_enterprise.svg',
  },
  {
    name: 'floor',
    label: 'Floor',
    label_th: 'ชั้น',
    icon: 'assets/svg/icon-menu/carbon_layers.svg',
  },
  {
    name: 'office',
    label: 'Office',
    label_th: 'ห้อง',
    icon: 'assets/svg/icon-menu/carbon_chart-treemap.svg',
  },
  {
    name: 'purpose',
    label: 'Purpose',
    label_th: 'วัตถุประสงค์',
    icon: 'assets/svg/icon-menu/flag.svg',
  },
  {
    name: 'billing',
    label: 'Billing',
    label_th: 'ค่าบริการ',
    icon: 'assets/svg/icon-menu/carbon_piggy-bank-slot.svg',
  },
  {
    name: 'product_list',
    label: 'Product List',
    label_th: 'รายการสิ่งของ',
    icon: 'assets/svg/icon-menu/carbon_product.svg',
  },
  {
    name: 'price',
    label: 'Price',
    label_th: 'ราคา',
    icon: 'assets/svg/icon-menu/currency.svg',
  },
  {
    name: 'special_condition',
    label: 'Special Condition',
    label_th: 'เงื่อนไขพิเศษ',
    icon: 'assets/svg/icon-menu/Condition Point.svg',
  },
];

export interface MasterDatMenues {
  name: MasterDataName;
  label: string;
  label_th: string;
  icon: string;
}

export type MasterDataName =
  | 'location'
  | 'property'
  | 'operation_unit'
  | 'building'
  | 'floor'
  | 'office'
  | 'purpose'
  | 'billing'
  | 'product_list'
  | 'price'
  | 'special_condition';

export const PURPOSE_VALID_LABEL = [
  'RENT',
  'COMMON SERVICE AND EQUIPMENT',
  'MANAGEMENT ELECTRICITY',
  'MANAGEMENT WATER SUPPLY',
  'CLEANING SERVICE',
  'MANAGEMENT ELECTRIC AND WATER',
];
